export { default as homeownersWithCarImg } from './homeowners.svg';
export { default as homeownersImg } from './homeowners-bundle-new.svg';
export { default as petImg } from './pet-bundle-new.svg';
export { default as rentersImg } from './renters-bundle-new.svg';
export { default as termLifeImg } from './life-bundle-new.svg';
export { default as teslaDesktopImg } from './bundles_tesla_desktop.svg';
export { default as teslaMobileImg } from './bundles_tesla_mobile.svg';
